import api from "../lib/api.ts";

// Get auction details by ID
export const getAuction = async (auctionId: number, auctionLaneId: number) => {
  try {
    const response = await api.get(
      `/auctions/${auctionId}?auctionLaneId=${auctionLaneId}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching auction:", error);
    throw error;
  }
};

// Get auction lane details by ID
export const getAuctionLane = async (auctionLaneId: number) => {
  try {
    const response = await api.get(`/auctionlanes/${auctionLaneId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching auction lane:", error);
    throw error;
  }
};

// Get auction lane with auction details
export const getAuctionLaneWithDetails = async (auctionLaneId: number) => {
  try {
    const response = await api.get(
      `/auctionlanes/${auctionLaneId}/with-details`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching auction lane with details:", error);
    throw error;
  }
};

// Get current vehicle for auction lane
export const getCurrentVehicle = async (auctionLaneId: number) => {
  try {
    const response = await api.get(`/bidding/current-vehicle/${auctionLaneId}`);
    return response?.data?.data;
  } catch (error) {
    console.error("Error fetching current vehicle:", error);
    throw error;
  }
};

// Get vehicle list for auction lane
export const getVehicleList = async (auctionLaneId: number) => {
  try {
    const response = await api.get(`/bidding/vehicle-list/${auctionLaneId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching vehicle list:", error);
    throw error;
  }
};

// Get auction stats
export const getAuctionStats = async (auctionLaneId: number) => {
  try {
    const response = await api.get(`/bidding/stats/${auctionLaneId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching auction stats:", error);
    throw error;
  }
};

// Get bid history for a specific vehicle
export const getBidHistory = async (
  auctionLaneId: number,
  vehicleId: number
) => {
  try {
    const response = await api.get(
      `/bidding/bid-history/${auctionLaneId}/${vehicleId}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching bid history:", error);
    throw error;
  }
};

// Get user bids with filters
export const getUserBids = async (
  userId?: number,
  auctionLaneId?: number,
  vehicleId?: number,
  underApproval?: number
) => {
  try {
    const params = new URLSearchParams();

    
    if (userId) params.append('userId', userId.toString());
    if (auctionLaneId) params.append('auctionLaneId', auctionLaneId.toString());
    if (vehicleId) params.append('vehicleId', vehicleId.toString());
    if (underApproval) params.append('underApproval', underApproval.toString());

    const response = await api.get(`/bidding/bids?${params.toString()}`);

    return response.data;
  } catch (error) {
    console.error("Error fetching user bids:", error);
    throw error;
  }
};

// Get user prebids with filters
export const getUserPrebids = async (
  auctionLaneId?: number,
  vehicleId?: number,
  userId?: number
) => {
  try {
    const params = new URLSearchParams();

    if (auctionLaneId) params.append("auctionLaneId", auctionLaneId.toString());
    if (vehicleId) params.append("vehicleId", vehicleId.toString());
    if (userId) params.append("userId", userId.toString());

    const response = await api.get(`/bidding/bids?${params.toString()}`);

    return response.data;
  } catch (error) {
    console.error("Error fetching user prebids:", error);
    throw error;
  }
};

// Get vehicle details by vehicle ID
export const getVehicleDetails = async (vehicleId: number) => {
  try {
    const response = await api.get(`/products/${vehicleId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching vehicle details:", error);
    throw error;
  }
};
